var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClonedEmptyState(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3569_97447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.3134 100.403C77.9281 100.403 100.314 78.017 100.314 50.4022C100.314 22.7875 77.9281 0.401367 50.3134 0.401367C22.6987 0.401367 0.3125 22.7875 0.3125 50.4022C0.3125 78.017 22.6987 100.403 50.3134 100.403Z",
    fill: "url(#paint0_linear_3569_97447)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8744 23.8208L100.313 53.8828C100.313 53.8828 99.583 89.5965 61.8288 99.0695L59.5569 99.5359C59.177 99.6136 58.7972 99.6807 58.4138 99.7373L56.4175 100.032L32.4806 73.3482L31.1273 72.3553L21.6543 58.0116L31.5319 51.7416L49.7994 69.4686L62.8429 57.5893C62.8429 57.5893 72.5686 45.4098 64.5142 38.5091L63.1503 32.209L69.8744 23.8208Z",
    fill: "url(#paint1_linear_3569_97447)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5575 39.6909L75.874 42.2615",
    stroke: "#CBB4FE",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2588 39.6909L24.9422 42.2615",
    stroke: "#CBB4FE",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9075 72.7967L65.0137 67.9224",
    stroke: "#CBB4FE",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5227 67.8662L31.7773 72.8536",
    stroke: "#CBB4FE",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1768 58.552L27.8902 56.0469",
    stroke: "#CBB4FE",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.068 58.552L72.3545 56.0469",
    stroke: "#CBB4FE",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2773 28.1754L69.1959 23.3223",
    stroke: "#CBB4FE",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5916 28.1754L31.6748 23.3223",
    stroke: "#CBB4FE",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2282 26.4408L50.1328 20.2026",
    stroke: "#CBB4FE",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2282 81.2911L50.1328 75.0547",
    stroke: "#CBB4FE",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.55 39.8293C45.2216 40.2996 44.5248 40.6922 43.9521 40.7265C42.013 40.8459 40.0727 41.3968 38.2766 42.4338C32.049 46.0292 29.9149 53.993 33.5101 60.2201C37.1056 66.4478 45.0688 68.582 51.2972 64.9861C53.0934 63.9491 54.5402 62.5432 55.6127 60.9234C55.9295 60.4459 56.617 60.0373 57.1892 59.9892C59.0022 59.8353 60.809 59.2954 62.4864 58.3269C68.6223 54.7844 70.7314 46.9113 67.1889 40.7754C63.6467 34.6403 55.7738 32.5302 49.638 36.0727C47.9606 37.0413 46.5899 38.3365 45.55 39.8293ZM58.0467 58.0225C57.4818 58.1243 57.1804 57.7225 57.3329 57.1696C58.2277 53.9269 57.8756 50.3434 56.061 47.2003C54.2464 44.0575 51.3193 41.9616 48.0637 41.1148C47.5085 40.9701 47.3111 40.5082 47.6819 40.0702C48.4738 39.1319 49.4323 38.311 50.5546 37.663C55.8133 34.6269 62.5624 36.4343 65.5985 41.693C68.6349 46.9523 66.8257 53.7009 61.567 56.737C60.4445 57.3851 59.2548 57.8052 58.0467 58.0225Z",
    fill: "#8F38EF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3569_97447",
    x1: 50.3134,
    y1: 0.401367,
    x2: 50.3134,
    y2: 100.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F7F0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0E1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3569_97447",
    x1: 88.5002,
    y1: 85.5,
    x2: 55.5002,
    y2: 45.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEA8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3569_97447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(0.3125 0.401367)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClonedEmptyState);
export default __webpack_public_path__ + "static/media/ClonedEmptyState.a64b5c9f5d70fedd48c8461947b134ce.svg";
export { ForwardRef as ReactComponent };